export default {
  'purchases.situation.OPEN': 'Open',
  'purchases.situation.AUTHORIZED': 'Authorized',
  'purchases.situation.CANCELED': 'Canceled',

  'purchases.list.header.code': 'Code',
  'purchases.list.header.company': 'Company',
  'purchases.list.header.provider': 'Provider',
  'purchases.list.header.documentNumber': 'Doc. Number',
  'purchases.list.header.releaseDate': 'Release Date',
  'purchases.list.header.situation': 'Situation',
  'purchases.list.header.boschStatus': 'Send status Bosch',
  'purchases.list.header.actions': 'Action',
  'purchases.list.column.actions.details': 'View/Edit',

  'purchases.searchBar.create': 'New Buy',
  'purchases.create.general': 'General',

  'purchases.situation': 'Situation: ',
  'purchases.newPurchase': 'New Purchase',
  'purchases.sendEmail': 'Send Email',
  'purchases.sendEmail.modal.form.for': 'For:',
  'purchases.sendEmail.modal.form.subject': 'Subject:',
  'purchases.sendEmail.modal.form.message': 'Message',
  'purchases.printOut': 'Print Out',
  'purchases.calculateTaxes': 'Calculate Taxes',
  'purchases.authorizePurchase': 'Authorize Purchase',
  'purchases.cancelPurchase': 'Cancel Purchase',

  'purchases.releases.form.code': 'Code',
  'purchases.releases.form.company': 'Company',
  'purchases.releases.form.invoiceKey': 'Invoice Key',
  'purchases.releases.form.supplier': 'Supplier',
  'purchases.releases.form.add.supplier': 'Register Supplier',
  'purchases.releases.form.releaseDate': 'Release Date',
  'purchases.releases.form.issuanceDate': 'Issuance Date',
  'purchases.releases.form.departureDate': 'Departure Date',
  'purchases.releases.form.noteTemplate': 'Note Template',
  'purchases.releases.form.series': 'Series',
  'purchases.releases.form.operationDestination': 'Operation Destination',
  'purchases.releases.form.internalOperation': '1 - Internal Operation',
  'purchases.releases.form.interstateOperation': '2 - Interstate Operation',
  'purchases.releases.form.foreignOperation': '3 - Foreign Operation',
  'purchases.releases.form.documentNumber': 'Document Number',
  'purchases.releases.form.shippingType': 'Shipping Type',
  'purchases.releases.form.recipient': 'Recipient',
  'purchases.releases.form.issuer': 'Issuer',
  'purchases.releases.form.freeShipping': 'Free Shipping',
  'purchases.releases.form.the3rd': 'The 3rd',
  'purchases.releases.form.documentType': 'Document Type',
  'purchases.releases.form.additionalData': 'Additional Data',
  'purchases.releases.form.invoiceFreight': 'Invoice Freight',
  'purchases.releases.form.shippingValue': 'Shipping Value ($)',
  'purchases.releases.form.expenditure': 'Expenditure ($)',
  'purchases.releases.form.discountValue': 'Discount Value ($)',
  'purchases.releases.form.amount': 'Amount ($)',
  'purchases.releases.form.includeIcms':
    'Freight, Expenses are included in the ICMS ST calculation base',
  'purchases.releases.form.includeIpi':
    'Freight, Expenses are included in the IPI calculation basis',
  'purchases.releases.form.expensesIndividually ':
    'Enter expenses individually',
  'purchases.releases.form.expensesIndividually.info':
    'When checking this option, the amounts of other expenses ' +
    'must be informed directly in the purchase items. ' +
    'After saving the purchase, it is not possible to change this option.',

  'purchases.btn.authorize.confirm.title': 'Confirmation',
  'purchases.btn.authorize.confirm.content':
    'Do you want to authorize the purchase and update item prices? Prices will only be adjusted in stock',
  'purchases.btn.authorize.modal.authorizeChange':
    'Authorize and change prices',
  'purchases.btn.authorize.modal.authorize': 'Authorize and not change prices',

  'purchases.details.itemsPurchase.selectPart': 'Select a Part',
  'purchases.details.itemsPurchase.selectConsumable': 'Select an Consumable',
  'purchases.details.itemsPurchase.selectService': 'Select a Service',
  'purchases.details.itemsPurchase.selectItemsOS': 'Select Items O.S',
  'purchases.details.itemsPurchase.table.budget': 'Budget',
  'purchases.details.itemsPurchase.table.manufacturerCode': 'Manufacturer Code',
  'purchases.details.itemsPurchase.table.description': 'Description',
  'purchases.details.itemsPurchase.table.manufacturer': 'Manufacturer',
  'purchases.details.itemsPurchase.table.qty': 'Quantity',
  'purchases.details.itemsPurchase.table.unitPrice': 'UN.Price',
  'purchases.details.itemsPurchase.table.discount': 'Disc.',
  'purchases.details.itemsPurchase.table.amount': 'Total Val.',
  'purchases.details.itemsPurchase.create.description': 'Description',
  'purchases.details.itemsPurchase.create.itemNumber': 'Nº item',
  'purchases.details.itemsPurchase.create.manufacturer': 'Manufacturer',
  'purchases.details.itemsPurchase.create.ncm': 'NCM',
  'purchases.details.itemsPurchase.create.cfop': 'CFOP',
  'purchases.details.itemsPurchase.create.unit': 'Unit',
  'purchases.details.itemsPurchase.create.quantity': 'Quantity',
  'purchases.details.itemsPurchase.create.unitPrice': 'Unit Price',
  'purchases.details.itemsPurchase.create.discountValue': 'Discount Value',
  'purchases.details.itemsPurchase.create.amount': 'Amount',
  'purchases.details.itemsPurchase.create.expenses': 'Expenses',

  'purchases.items.part.tabOne.general': 'General',
  'purchases.items.task.issqn': 'ISSQN',
  'purchases.items.part.tabTwo.icms': 'ICMS',
  'purchases.items.part.tabThree.ipi': 'IPI',
  'purchases.items.task.irpjAndCsll': 'IRPJ/CSLL',
  'purchases.items.part.tabFour.pis': 'PIS',
  'purchases.items.part.tabFive.cofins': 'COFINS',
  'purchases.items.part.tabSix.icmsOperInter': 'ICMS OPER INTER',
  'purchases.items.part.tabSeven.iI': 'II',

  'purchases.details.itemsPurchase.issqn.quotaIssqn': 'Quota ISSQN',
  'purchases.details.itemsPurchase.issqn.baseIssqn': 'Base ISSQN',
  'purchases.details.itemsPurchase.issqn.valueIssqn': 'ISSQN Value',
  'purchases.details.itemsPurchase.irpjAndCsll.quotaIrpj': 'Quota IRPJ (%)',
  'purchases.details.itemsPurchase.irpjAndCsll.valueIrpj': 'Value IRPJ',
  'purchases.details.itemsPurchase.irpjAndCsll.quotaCsll': 'Quota. CSLL (%)',
  'purchases.details.itemsPurchase.irpjAndCsll.valueCsll': 'Value CSLL',

  'purchases.details.itemsPurchase.icms.taxRegime': 'Tax regime',
  'purchases.details.itemsPurchase.icms.taxRegime.normalRegime':
    'Normal Regime',
  'purchases.details.itemsPurchase.icms.taxRegime.simpleNational':
    'Simple National',
  'purchases.details.itemsPurchase.icms.taxRegime.simpleNationalExcess':
    'Simple National with Excess Sublimit',
  'purchases.details.itemsPurchase.icms.taxRegime.cstIcms': 'CST ICMS',
  'purchases.details.itemsPurchase.icms.taxRegime.csosn': 'CSOSN',
  'purchases.details.itemsPurchase.icms.taxRegime.originIcms': 'Origin',
  'purchases.details.itemsPurchase.icms.taxRegime.originIcms.zero':
    '0 - National, except those indicated in codes 3, 4, 5 and 8',
  'purchases.details.itemsPurchase.icms.taxRegime.originIcms.one':
    '1 - Foreign - Direct import, except as indicated in code 6',
  'purchases.details.itemsPurchase.icms.taxRegime.originIcms.two':
    '2 - Foreign - Acquired in the domestic market, except as indicated in code 7',
  'purchases.details.itemsPurchase.icms.taxRegime.originIcms.three':
    '3 - National, merchandise or good with Import Content greater than 40% and less than or equal to 70%',
  'purchases.details.itemsPurchase.icms.taxRegime.originIcms.four':
    '4 - National, whose production has been carried out in accordance with the basic production processes dealt with in the legislation mentioned in the Adjustments',
  'purchases.details.itemsPurchase.icms.taxRegime.originIcms.five':
    '5 - National, merchandise or good with Import Content less than or equal to 40%',
  'purchases.details.itemsPurchase.icms.taxRegime.originIcms.six':
    '6 - Foreign - Direct import, without national similar, included in the list of CAMEX and natural gas',
  'purchases.details.itemsPurchase.icms.taxRegime.originIcms.seven':
    '7 - Foreign - Acquired in the domestic market, with no national similar, on the CAMEX and natural gas list',
  'purchases.details.itemsPurchase.icms.taxRegime.originIcms.eight':
    '8 - National, merchandise',
  'purchases.details.itemsPurchase.icms.taxRegime.icms': 'ICMS',
  'purchases.details.itemsPurchase.icms.taxRegime.modBcIcms':
    'BC ICMS determination method',
  'purchases.details.itemsPurchase.icms.taxRegime.modBcIcms.zero':
    '0 - Value Added Margin (%)',
  'purchases.details.itemsPurchase.icms.taxRegime.modBcIcms.one':
    '1 - Agenda (Value)',
  'purchases.details.itemsPurchase.icms.taxRegime.modBcIcms.two':
    '2 - Price Listed Max. (Value)',
  'purchases.details.itemsPurchase.icms.taxRegime.modBcIcms.three':
    '3 - Transaction value',
  'purchases.details.itemsPurchase.icms.taxRegime.reductionIcms':
    '(%) BC ICMS Reduction',
  'purchases.details.itemsPurchase.icms.taxRegime.baseIcms': 'BC ICMS',
  'purchases.details.itemsPurchase.icms.taxRegime.quotaIcms': 'Aliq. ICMS',
  'purchases.details.itemsPurchase.icms.taxRegime.valueIcms': 'ICMS Value',
  'purchases.details.itemsPurchase.icms.taxRegime.baseFcp':
    'FCP Calculation Basis',
  'purchases.details.itemsPurchase.icms.taxRegime.quotaFcp': 'FCP aliquot',
  'purchases.details.itemsPurchase.icms.taxRegime.valueFcp': 'FCP Value',
  'purchases.details.itemsPurchase.icms.taxRegime.valueIcmsUnencumbered':
    'ICMS amount relieved',
  'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms':
    'Reason for exemption from ICMS',
  'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.one': '1 - Taxi',
  'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.three':
    '3 - Use in agriculture',
  'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.four':
    '4 - Fleet/Lessor',
  'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.five':
    '5 - Diplomatic/Consular',
  'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.six':
    '6 - Utilities and Motorcycles of the Western Amazon and Free Trade Areas (Resolution 714/88 and 790/94 - CONTRAN and its amendments)',
  'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.seven':
    '7 - SUFRAME',
  'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.eigth':
    '8 - Sale to Public Entity',
  'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.nine':
    '9 - Others',
  'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.ten':
    '10 - Disabled Driver (ICMS Agreement 38/12)',
  'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.eleven':
    '11 - Non-Conductive Disabled (ICMS Agreement 38/12)',
  'purchases.details.itemsPurchase.icms.taxRegime.motDesIcms.twelven':
    '12 - Agricultural promotion and development agency',
  'purchases.details.itemsPurchase.icmsSt.taxRegime': 'ICMS ST',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.modBcIcmsSt':
    'Method of determination of BC ICMS ST',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.modBcIcmsSt.zero':
    '0 - Price list or suggested maximum',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.modBcIcmsSt.one':
    '1 - Negative List (value)',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.modBcIcmsSt.two':
    '2 - Positive List (value)',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.modBcIcmsSt.three':
    '3 - Neutral List (value)',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.modBcIcmsSt.four':
    '4 - Added Value Margin (%)',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.modBcIcmsSt.five':
    '5 - Agenda (value)',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.reductionIcmsSt':
    '(%) Reduction BC ICMS ST',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.baseIcmsSt': 'BC ICMS ST',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.quotaIcmsSt':
    'Aliq. ICMS ST',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.valueIcmsSt':
    'ICMS ST value',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.quotaMvaSt':
    '(%) Subst. Trib (MVA)',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.baseIcmsStWithheld':
    'BC ICMS ST withheld',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.valueIcmsStWithheld':
    'ICMS ST withheld value',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.baseFcpSt':
    'Calculation Basis FCP ST',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.quotaFcpSt': 'FCP ST rate',
  'purchases.details.itemsPurchase.icmsSt.taxRegime.valueFcpSt': 'FCP ST value',

  'purchases.details.itemsPurchase.ipi.taxRegime.cstIpi': 'CST IPI',
  'purchases.details.itemsPurchase.ipi.taxRegime.quotaIpi': 'Alíq. IPI',
  'purchases.details.itemsPurchase.ipi.taxRegime.baseIpi': 'BC. IPI',
  'purchases.details.itemsPurchase.ipi.taxRegime.valueIpi': 'IPI Value',

  'purchases.details.itemsPurchase.pis.taxRegime.title': 'PIS',
  'purchases.details.itemsPurchase.pis.taxRegime.cstPis': 'CST PIS',
  'purchases.details.itemsPurchase.pis.taxRegime.calcPercentPis':
    'Calculation Type',
  'purchases.details.itemsPurchase.pis.taxRegime.calcPercentPis.percentage':
    'Percentage',
  'purchases.details.itemsPurchase.pis.taxRegime.calcPercentPis.value': 'Value',
  'purchases.details.itemsPurchase.pis.taxRegime.quotaPis': 'Aliq. PIS',
  'purchases.details.itemsPurchase.pis.taxRegime.basePis': 'BC. PIS',
  'purchases.details.itemsPurchase.pis.taxRegime.valueUnityPis':
    'Vlr. PIS per unit',
  'purchases.details.itemsPurchase.pis.taxRegime.valuePis': 'PIS Value',
  'purchases.details.itemsPurchase.pisSt.taxRegime.title': 'PIS ST',
  'purchases.details.itemsPurchase.pis.taxRegime.valueUnityPisSt':
    'Calculation Type',
  'purchases.details.itemsPurchase.pisST.taxRegime.quotaPisSt': 'Aliq. PIS ST',
  'purchases.details.itemsPurchase.pisST.taxRegime.valueUnityPisSt':
    'Vlr. PIS ST per unit',
  'purchases.details.itemsPurchase.pisST.taxRegime.basePisSt': 'BC. PIS ST',
  'purchases.details.itemsPurchase.pisST.taxRegime.valuePisSt': 'PIS ST Value',

  'purchases.details.itemsPurchase.cofins.taxRegime.title': 'COFINS',
  'purchases.details.itemsPurchase.cofins.taxRegime.cstCofins': 'CST COFINS',
  'purchases.details.itemsPurchase.cofins.taxRegime.quotaCofins':
    'Aliq. COFINS',
  'purchases.details.itemsPurchase.cofins.taxRegime.baseCofins': 'BC. COFINS',
  'purchases.details.itemsPurchase.cofins.taxRegime.calcPercentCofins':
    'Type of calculation',
  'purchases.details.itemsPurchase.cofins.taxRegime.valueUnityCofins':
    'Vlr. COFINS per unit',
  'purchases.details.itemsPurchase.cofins.taxRegime.valueCofins':
    'COFINS Value',
  'purchases.details.itemsPurchase.cofinsSt.taxRegime.title': 'COFINS ST',
  'purchases.details.itemsPurchase.cofinsSt.taxRegime.quotaCofinsSt':
    'Aliq. COFINS ST',
  'purchases.details.itemsPurchase.cofinsSt.taxRegime.valueUnityCofinsSt':
    'Vlr. COFINS ST per unit',
  'purchases.details.itemsPurchase.cofinsSt.taxRegime.calcPercentCofinsSt':
    'Type of calculation',
  'purchases.details.itemsPurchase.cofinsSt.taxRegime.baseCofinsSt':
    'BC. COFINS ST',
  'purchases.details.itemsPurchase.cofinsSt.taxRegime.valueCofinsSt':
    'COFINS ST Value',

  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.percentIcmsFcp':
    '(%)ICMS FCP',
  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.baseInterstateIcms':
    'BC ICMS Interstate',
  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.quotaIcmsUfDestination':
    'Aliq. ICMS UF destination',
  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.quotaInterstateIcms':
    'Aliquota Interstate',
  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.quotaInterstateIcms.zero':
    '4% interstate rate for imported products',
  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.quotaInterstateIcms.one':
    '7% for the States of origin in the South and Southeast (except ES), destined for the States of the North, Northeast, Midwest and Espírito Santo',
  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.quotaInterstateIcms.two':
    '12% for other cases.',
  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.percentProvisionalParticipation':
    '(%)Provisional sharing',
  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.percentProvisionalParticipation.zero':
    '40% in 2016',
  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.percentProvisionalParticipation.one':
    '60% in 2017',
  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.percentProvisionalParticipation.two':
    '80% in 2018',
  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.percentProvisionalParticipation.three':
    '100% from 2019',
  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.valueInterstateDestinationIcms':
    'Value ICMS Recipient',
  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.valueInterstateOriginIcms':
    'Value ICMS Sender',
  'purchases.details.itemsPurchase.ocmsOperInter.taxRegime.valueIcmsFcp':
    'Value ICMS FCP',

  'purchases.details.itemsPurchase.iI.taxRegime.valueBaseOfImportTax':
    'BC Value of Import Tax',
  'purchases.details.itemsPurchase.iI.taxRegime.valueOfCustomsExpenses':
    'Value of customs expenses',
  'purchases.details.itemsPurchase.iI.taxRegime.valueImportTax':
    'Import Tax Amount',
  'purchases.details.itemsPurchase.iI.taxRegime.amountOfTaxOnFinancialTransactions':
    'Amount of Tax on Financial Transactions',

  'purchases.details.itemsPurchase.notifications.remove.confirm.title':
    'Do you really want to delete this Item?',
  'purchases.details.itemsPurchase.notifications.remove.confirm.content':
    'Upon removing the Item, all information will be permanently lost. Do you still want to continue?',
  'purchases.details.notifications.remove.success.title': 'Item removed',
  'purchases.details.notifications.remove.success.description':
    'The item has been successfully removed!',

  'purchase.details.taxes.form.icmsValue': 'ICMS Value',
  'purchase.details.taxes.form.icmsStValue': 'ICMS ST Value',
  'purchase.details.taxes.form.pisValue': 'PIS Value',
  'purchase.details.taxes.form.pisStValue': 'PIS ST Value',
  'purchase.details.taxes.form.ipiValue': 'IPI Value',
  'purchase.details.taxes.form.cofinsValue': 'COFINS Value',
  'purchase.details.taxes.form.cofinsStValue': 'COFINS ST Value',
  'purchase.details.taxes.form.issqnValue': 'ISSQN Value',
  'purchase.details.taxes.form.fcpValue': 'FCP Value',
  'purchase.details.taxes.form.fcpStValue': 'FCP ST Value',
  'purchase.details.taxes.form.bcValue': 'BC Value of Import Tax',
  'purchase.details.taxes.form.expensesValue': 'Value of customs expenses',
  'purchase.details.taxes.form.taxAmountValue': 'Import Tax Amount',
  'purchase.details.taxes.form.transactionsFinancialValue':
    'Amount of Tax on Financial Transactions',

  'purchases.filters.workerOrderNumber': 'Budget Number',
  'purchases.filters.company': 'Company',
  'purchases.filters.supplier': 'Supplier',
  'purchases.filters.documentNumber': 'Doc. Number',
  'purchases.filters.releaseDate': 'Release Date',
  'purchases.filters.situation': 'Situation',

  'purchases.notifications.create.success.title': 'Success!',
  'purchases.notifications.create.success.description':
    'Your Purchase has been successfully created!',

  'purchases.notifications.update.success.title': 'Success!',
  'purchases.notifications.update.success.description':
    'Your Purchase has been successfully created!',

  'purchases.notifications.remove.confirm.title':
    'Do you really want to delete this Purchase?',
  'purchases.notifications.remove.confirm.content':
    'Upon removing your Purchase, all information will be permanently lost. Do you still want to continue?',
  'purchases.notifications.remove.success.title': 'Purchase removed',
  'purchases.notifications.remove.success.description':
    'Purchase successfully removed!',

  'purchases.notifications.authorize.success.title': 'Authorized purchase',
  'purchases.notifications.authorize.success.description':
    'The Purchase was authorized successfully!',

  'purchases.notifications.canceled.success.title': 'Purchase canceled',
  'purchases.notifications.canceled.success.description':
    'Purchase successfully canceled!',
  'itemsPurchase.notifications.create.success.title': 'Success!',
  'itemsPurchase.notifications.create.success.description':
    'Your Purchase Item has been successfully created!',

  'itemsPurchase.notifications.update.success.title': 'Success!',
  'itemsPurchase.notifications.update.success.description':
    'Your Purchase Item has been successfully changed!',

  'itemsPurchase.notifications.calcTaxes.success.description':
    'Tributes of the purchase item calculated successfully!',

  'itemsPurchase.error.message.csosnIcms': 'CSOSN ICMS not informed',
};
